import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import CharacterForm from './CharacterForm';
import api from "../api";

function CreateCharacter({ loadingBarRef }) {
    const { t } = useTranslation();
    const getEmptyCharacterData = () => ({
        name: '',
        logo_url: '',
        image_url: '',
        translations: {
            en: { ultimate_name: '', ultimate_description: '', specialized_weapons: '', description: '' },
            ru: { ultimate_name: '', ultimate_description: '', specialized_weapons: '', description: '' },
            ua: { ultimate_name: '', ultimate_description: '', specialized_weapons: '', description: '' },
            ko: { ultimate_name: '', ultimate_description: '', specialized_weapons: '', description: '' },
            fr: { ultimate_name: '', ultimate_description: '', specialized_weapons: '', description: '' },
        },
        skills: []
    });
    const [newCharacterData, setNewCharacterData] = useState(getEmptyCharacterData());
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        if (loadingBarRef.current) loadingBarRef.current.continuousStart();
        try {
            const accessToken = localStorage.getItem('access_token');
            const translationsArray = Object.entries(newCharacterData.translations).map(([lang, trans]) => ({
                language_code: lang,
                ...trans
            }));
            const dataToSend = {
                ...newCharacterData,
                translations: translationsArray
            };
            const response = await api.post(`${process.env.REACT_APP_API_URL}/api/admin/character`, dataToSend, {
                headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' }
            });
            if (response.status === 200 || response.status === 201) {
                await Swal.fire({
                    text: t('characters.createSuccess'),
                    icon: 'success',
                    background: '#1a1a1a',
                    color: '#b3b3b3',
                    iconColor: '#00ff00',
                    confirmButtonText: t('posts.ok'),
                    customClass: { popup: 'swal2-dark-popup', confirmButton: 'swal2-dark-button' }
                });
                setNewCharacterData(getEmptyCharacterData());
            }
        } catch (error) {
            await Swal.fire({
                text: t('characters.createError'),
                icon: 'error',
                background: '#1a1a1a',
                color: '#b3b3b3',
                iconColor: '#ff0000',
                confirmButtonText: t('posts.ok'),
                customClass: { popup: 'swal2-dark-popup', confirmButton: 'swal2-dark-button' }
            });
        } finally {
            setIsSubmitting(false);
            if (loadingBarRef.current) loadingBarRef.current.complete();
        }
    };

    return (
        <CharacterForm
            characterData={newCharacterData}
            setCharacterData={setNewCharacterData}
            onSubmit={handleCreateSubmit}
            isCreating={true}
            isSubmitting={isSubmitting}
            loadingBarRef={loadingBarRef}
        />
    );
}

export default CreateCharacter;